<template>
	<div>
		<v-container fluid grid-list-xl>
			<v-layout row wrap border-rad-sm overflow-hidden>
				<v-flex md3 sm6 xs12>
					<app-card>
						<div class="d-custom-flex justify-space-between">
							<div>
								<h2>{{data.resumenMes.recibido}}</h2>
								<router-link :to="{ name: 'Direccionamientos'}"><p>Direccionamientos</p></router-link>
							</div>
							<div>
								<span class="icon-style">
									<v-icon color="primary">ti ti-direction-alt</v-icon>
								</span>
							</div>
						</div>
					</app-card>
				</v-flex>
				<v-flex md3 sm6 xs12>
					<app-card customClasses="user-stats-wrap">
						<v-card-title class="pa-0 ma-0">
							<span class="caption"><router-link :to="{ name: 'Programaciones'}">Programados</router-link></span>
							<v-spacer></v-spacer>
							<v-icon color="purple">ti ti-timer</v-icon>
						</v-card-title>
						<h4>{{data.resumenMes.programado}} ({{data.resumenMes.programado ? ((data.resumenMes.programado * 100) / data.resumenMes.recibido).toFixed(2) : 0}}%)</h4>
						<v-progress-linear class="mb-2" height="6" :value="data.resumenMes.programado ? (data.resumenMes.programado * 100) / data.resumenMes.recibido : 0"></v-progress-linear>
					</app-card>
				</v-flex>
				<v-flex md3 sm6 xs12>
					<app-card customClasses="user-stats-wrap">
						<v-card-title class="pa-0 ma-0">
							<span class="caption"><router-link :to="{ name: 'Entregas'}">Entregados</router-link></span>
							<v-spacer></v-spacer>
							<v-icon color="success">ti ti-package</v-icon>
						</v-card-title>
						<h4>{{data.resumenMes.entregado}} ({{data.resumenMes.entregado ? ((data.resumenMes.entregado * 100) / data.resumenMes.recibido).toFixed(2) : 0}}%)</h4>
						<v-progress-linear class="mb-2" height="6" :value="data.resumenMes.entregado ? (data.resumenMes.entregado * 100) / data.resumenMes.recibido : 0"></v-progress-linear>
					</app-card>
				</v-flex>
				<v-flex md3 sm6 xs12>
					<app-card customClasses="user-stats-wrap">
						<v-card-title class="pa-0 ma-0">
							<span class="caption"><router-link :to="{ name: 'ReportesEntrega'}">Reportados</router-link></span>
							<v-spacer></v-spacer>
							<v-icon color="info">ti ti-export</v-icon>
						</v-card-title>
						<h4>{{data.resumenMes.reportado}} ({{data.resumenMes.reportado ? ((data.resumenMes.reportado * 100) / data.resumenMes.recibido).toFixed(2) : 0}}%)</h4>
						<v-progress-linear class="mb-2" height="6" :value="data.resumenMes.reportado ? (data.resumenMes.reportado * 100) / data.resumenMes.recibido : 0"></v-progress-linear>
					</app-card>
				</v-flex>
			</v-layout>
		</v-container>
		<app-section-loader :status="loading"></app-section-loader>
	</div>
</template>

<script>
export default {
  components: {
  },
    data: () => ({
        loading: true,
		data: {
            resumenMes:{
                recibido: 0,
                programado: 0,
                entregado: 0,
                reportado: 0
			}
		}
    }),
	created () {
        this.getData()
	},
	methods: {
      getData () {
          this.axios.get(`dashboard`)
              .then((response) => {
                  this.data = response.data
                  this.loading = false
              }).catch(e => {
              this.loading = false
              this.$store.commit('snackbar', {color: 'error', message: `al traer la data del dashboard`, error: e})
          })
	  }
	}
}
</script>
